"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/prop-types */
/* eslint-disable no-unsafe-negation */
/* eslint-disable no-nested-ternary */
/* eslint-disable func-names */
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var JSONDisplay = function (props) {
    var _a = react_1.default.useState([]), collapsed = _a[0], setCollapsed = _a[1];
    if (!props.jsonObject)
        return null;
    var formatKey = function (value) {
        var returnValue = value
            .replaceAll("_", " ")
            .replace(/[A-Z]/g, function (txt) {
            return " " + txt.charAt(0);
        })
            .replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
        return returnValue;
    };
    var displayGrid = function (object, preserveLabels, preserveOrder, parent, supress) { return (react_1.default.createElement(core_1.Grid, { container: true, key: parent },
        !supress && (react_1.default.createElement(core_1.Grid, { item: true, xs: 12 }, "\u00A0")),
        Array.isArray(object)
            ? object.map(function (entry, index) {
                return typeof entry !== "object" ? (react_1.default.createElement(core_1.Grid, { item: true, xs: 12, key: index },
                    react_1.default.createElement(core_1.Typography, null, "" + entry))) : (displayGrid(entry, preserveLabels, preserveOrder, "" + (parent ? parent + "." : "") + (index + 1), index === 0));
            })
            : Object.keys(object)
                .sort(function (a, b) { return (preserveOrder ? 0 : a < b ? -1 : 1); })
                .map(function (key, idx) {
                var displayValue = object[key];
                var canCollapse = false;
                if (displayValue instanceof Object) {
                    canCollapse = true;
                    displayValue = displayGrid(displayValue, preserveLabels, preserveOrder, "" + (parent ? parent + "." : "") + (idx + 1));
                }
                else {
                    displayValue = react_1.default.createElement(core_1.Typography, null, "" + displayValue);
                }
                var collapseKey = "" + (parent ? parent + "." : "") + (idx + 1);
                return (react_1.default.createElement(react_1.default.Fragment, { key: key },
                    react_1.default.createElement(core_1.Grid, { item: true, xs: 3 },
                        props.collapsible && canCollapse ? (collapsed.includes(collapseKey) ? (react_1.default.createElement(core_1.IconButton, { size: "small", onClick: function () {
                                return setCollapsed(function (prevCollapsed) {
                                    return prevCollapsed.filter(function (val) { return val !== collapseKey; });
                                });
                            } },
                            react_1.default.createElement(icons_1.ExpandMore, null))) : (react_1.default.createElement(core_1.IconButton, { size: "small", onClick: function () {
                                return setCollapsed(function (prevCollapsed) { return __spreadArray(__spreadArray([], prevCollapsed), [
                                    collapseKey
                                ]); });
                            } },
                            react_1.default.createElement(icons_1.ExpandLess, null)))) : (""),
                        react_1.default.createElement(core_1.Typography, { display: "inline" }, preserveLabels ? key : formatKey(key))),
                    react_1.default.createElement(core_1.Grid, { item: true, xs: 9 },
                        react_1.default.createElement(core_1.Collapse, { in: !collapsed.includes(collapseKey) }, displayValue))));
            }))); };
    return displayGrid(props.jsonObject, props.preserveLabels, props.preserveOrder);
};
exports.default = JSONDisplay;
JSONDisplay.propTypes = {
    jsonObject: prop_types_1.default.object,
    preserveLabels: prop_types_1.default.bool,
    preserveOrder: prop_types_1.default.bool,
    collapsible: prop_types_1.default.bool
};
